import '../index.scss';
import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import PropTypes from 'prop-types';
import { getClaimDetails } from '../repositories';

class ReplaceMentPart extends Component {

    state = {
        replaceMentPart: [],
    };

 ReplaceMentPartColumnDefinitions = [
     {
         field: 'replacementPart',
         headerName: 'Part Number / Description',
         valueGetter:
            function replacementPartFunction ( params ) {

                const { replacementPart } = params.data;
                const { replacementPartDescription } = params.data;
                const divider = '/';
                return replacementPart + divider + replacementPartDescription;

            },
     },
     {
         field: 'returnPartCode',
         headerName: 'Return Part Indicator',
     },
     {
         field: 'amounts.warrantyPartCount',
         headerName: 'Quantity',
     },
     {
         field: 'amounts.warrantyPartAmountUsd',
         headerName: 'Value $',
         valueGetter:
         function warrantyPartAmountFunction ( params ) {

             const { warrantyPartAmountUsd } = params.data.amounts;
             const doller = '$';
             return ( doller + warrantyPartAmountUsd );

         },
     },
     {
         field: 'amounts.replacementPartCostUsd',
         headerName: 'Total $',
         valueGetter:
         function warrantyPartAmount ( params ) {

             const { replacementPartCostUsd } = params.data.amounts;
             const doller = '$';
             return ( doller + replacementPartCostUsd );

         },
     },
 ];

LaborColumnDefinitions = [
    {
        field: 'jobNumber',
        headerName: 'SPG',
        width: 120,
    },
    {
        field: 'amounts.laborRequiredHours',
        headerName: 'SPG Hours',
        width: 120,
    },
    {
        field: 'amounts.laborHours',
        headerName: 'Hours Prod',
        width: 120,
    },
    {
        field: 'techId',
        headerName: 'Technician Id',
        width: 120,
    },
    {
        field: 'techCertified',
        headerName: 'Technician Certified ?',
        width: 150,
    },
    {
        field: 'laborType',
        headerName: 'Labor Code',
        width: 120,
    },
    {
        field: 'amounts.laborRateUsd',
        headerName: 'Labor Rate',
        width: 120,
    },
    {
        field: 'amounts.laborAmountUsd',
        headerName: 'Extended ',
        width: 120,
    },
];

rowSelection = 'single';

    componentWillMount = () => {

        this.loadDefault( this.props.claimFor, this.props.claimNumber );

    }

    componentWillReceiveProps ( nextProps ) {

        if ( this.props.claimNumber !== nextProps.claimNumber ) {

            this.loadDefault( this.props.claimFor, nextProps.claimNumber );

        }

    }

    loadDefault = ( mode, id ) => {

        getClaimDetails( mode, id ).then( response => {

            this.setState( {
                replaceMentPart: response,
            } );


        } );

    };

  onGridReady = params => {

      this.gridApi = params.api;
      document.querySelector( '.replacementPart-grid' ).style.height = '';

  }

  render () {

      return (
          <div className="ag-theme-balham ag-theme-popup replacementPart-grid">
              <AgGridReact
                  columnDefs={this.props.claimFor === 'claimReplacementParts' ? this.ReplaceMentPartColumnDefinitions : this.LaborColumnDefinitions}
                  rowData={this.state.replaceMentPart}
                  domLayout="autoHeight"
                  onGridReady={this.onGridReady}
                  popupParent={document.body}
                  enableCellTextSelection={true}
              />
          </div>

      );

  }

}
ReplaceMentPart.propTypes = {
    claimFor: PropTypes.string.isRequired,
    claimNumber: PropTypes.string.isRequired,
};
export default ReplaceMentPart;
